<script lang="ts">
  import VerifiedDoc from '$shared/images/emptyPage/verified-doc.svg';
  import EntityMeta from '$shared/atoms/EntityMeta/EntityMeta.svelte';
  import Label from '$provider/constants/Label';
  import Title from '$shared/atoms/Title/Title.svelte';
</script>

<div class="comp-ama-merge-result-info">
  <div class="meta">
    <EntityMeta meta={{ source: Label.AmericanMedicalAssociation }} showIcon />
  </div>
  <div class="result-content">
    <div class="image"><img src={VerifiedDoc} alt="Verified Result" /></div>
    <div class="title"><Title type="h2">AMA Results</Title></div>
    <div class="desc">Preview only. Verified results will be imported when merge is complete</div>
  </div>
</div>

<style>
  .comp-ama-merge-result-info {
    width: 100%;
  }
  .result-content {
    height: 260px;
    margin-top: 16px;
    padding: 12px;
    text-align: center;
    background-color: #f6f7fa;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .image {
    margin-bottom: 14px;
  }
  .desc {
    margin-top: 12px;
    color: var(--grey-dark);
  }
</style>
